import { CustomerSettings } from '../../classes/customer-settings';
import { autoinject } from 'aurelia-framework';
import { BalanceReportViewModel, GlReportsClient } from '@dynamik/common/clients/reporting-clients';
import { debounceTime, ReplaySubject, shareReplay, switchMap, tap } from '../../rxjs-local';
import { differenceInSeconds } from '../../date-fns-local';

@autoinject()
export class PogoReportDataService {
  constructor(private customerSettingsClass: CustomerSettings, private glReportsClient: GlReportsClient) { }

  loading$ = new ReplaySubject<boolean>(1);
  prevCompanyId: number;
  prevDate: string;
  prevTimestamp: Date;
  cachedResponse: BalanceReportViewModel;

  data$ = this.customerSettingsClass.filter$
    .pipe(
      debounceTime(500),
      tap(() => this.loading$.next(true)),
      switchMap(async filter => {
        const useCache = filter.customer.companyId === this.prevCompanyId && filter.to === this.prevDate && differenceInSeconds(new Date(), this.prevTimestamp) < 30;
        this.prevCompanyId = filter.customer.companyId;
        this.prevDate = filter.to;
        return useCache ? this.cachedResponse : this.glReportsClient.balance(filter.customer.companyId, filter.to).catch(e => e as Error);
      }),
      tap(x => {
        if (!(x instanceof Error)) {
          this.cachedResponse = x;
          this.prevTimestamp = new Date();
        }
        this.loading$.next(false);
      }),
      shareReplay({ refCount: true })
    );
}
